// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2aPLZ","savePackageButton":"ClientWallet_savePackageButton__1w_Oy"};